import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/appQr.svg';

export const IconAppQr = createIconComponent(Icon);
